import * as React from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { IAC } from "../../../../Common/AdviserCharges/Components/IAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { RIAC } from "../../../../Common/AdviserCharges/Components/RIAC";
import { AdviserChargesContents } from "../../../../Common/AdviserCharges/Resource/Contents";
import { ChargesOnIllustration } from "../../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";

interface IAdviserChargesProps extends IProcessComponentProps {}

interface IAdviserChargesState {}

export class AdviserCharges extends ProcessComponent<IAdviserChargesProps, IAdviserChargesState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    private canAddIAC = () => {
        const data = this.props.data?.PensionQuote;
        const selectedProducts = this.props.data?.SelectedProducts;

        const isImmediateTaxFreeLumpSum = selectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
                ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        const singlePayment = data?.ClientSinglePayment !== null;
        const uncrystalised = data?.PensionTransfers?.some(ele => ele.PensionSource === PensionArrangementType.Accumulation);

        return !(isImmediateTaxFreeLumpSum && (singlePayment || uncrystalised));
    }

    public render(): JSX.Element {
        return (
            <>
                <h2 className="mb-22">Adviser charges</h2>

                <h3 className="heading-underlined mb-26">{AdviserChargesContents.ProductLevel}</h3>

                {this.canAddIAC() && (<IAC type={SubAccountType.Npr} {...this.getProps("PensionQuote")} />) }

                <RIAC type={SubAccountType.Npr} {...this.getProps("PensionQuote")} />

                <OAC type={SubAccountType.Npr} {...this.getProps("PensionQuote")} />

                <ChargesOnIllustration {...this.getProps("PensionQuote")} />
            </>
        );
    }
}
